// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"867fe6f3","513":"dbaf4137","545":"61763bac","787":"eb470f2d"}[chunkId] + ".chunk.js";
};